import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor tagcloud
 */
export default class TagcloudSeoValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.attributes - tag attributes
   * @param {String} deps.title
   * @param {Object} deps.tags // contains {label, link, title}
   */
}
